function initRecommendedLocationsComponent(app) {
    app.component('recommended-locations', {
        template: '#recommended-locations-template',
        props: {
            cities: {
                required: true,
            },
            url: {
                type: String,
            },
            contentClass: {
                type: String,
            },
        },
        data() {
            return {
                coordinates: [141.427, 154.427, 162.576, 162.576, 162.576, 154.576, 142.427],
                cityOrders: [6, 4, 2, 1, 3, 5, 7],
            };
        },
        methods: {
            getCircleX(index) {
                return 326 + index * 210;
            },
            getCircleY(index) {
                return 141.427 + (index % 2 === 0 ? 1 : -1) * 5 * (index === 2 || index === 4 ? 5 : 1);
            },
            getCircleRadius(index) {
                return 60 + ((index * index) % 3) * 5;
            },
            getInnerElementX(index) {
                return 326 + index * 210 + (index % 4 === 0 ? -1 : 1) * 5;
            },
            getTextY(index) {
                return this.coordinates[index] + (index % 2 === 0 ? 40 : -31);
            },
            getUrl(order) {
                const city = this.getCity(order);
                return city.searchUrl;
            },
            getCity(index) {
                return this.cities.find((c) => c.order === index);
            },
            scrollToCenter() {
                const scrollElement = this.$refs.simplebar.value.getScrollElement();
                const content = this.$refs.content.getBoundingClientRect();
                const xShift = (content.width - scrollElement.clientWidth) / 2;
                // NOTE: scrollTo is not defined in Edge
                if (scrollElement.scrollTo) {
                    scrollElement.scrollTo(xShift, 0);
                } else {
                    scrollElement.scrollLeft = xShift;
                }
            },
        },
        mounted() {
            this.scrollToCenter();
            window.addEventListener('resize', this.scrollToCenter, false);
        },
    });
}

export default initRecommendedLocationsComponent;
